import * as _ from "lodash";

export enum UnitKindEnum {
  COUNT = "count",
  TRAFFIC = "traffic",
  PERCENT = "percent",
  VOLUME = "volume",
}

export enum UnitNameEnum {
  TRAFFIC_PBPS = "Pbps",
  TRAFFIC_TBPS = "Tbps",
  TRAFFIC_GBPS = "Gbps",
  TRAFFIC_MBPS = "Mbps",
  TRAFFIC_KBPS = "Kbps",
  TRAFFIC_BPS = "bps",

  COUNT_PETA = "P",
  COUNT_TRILLION = "T",
  COUNT_BILLION = "B",
  COUNT_MILLION = "M",
  COUNT_K = "K",

  COUNT_NO_UNIT = "",

  VOLUME_PB = "PB",
  VOLUME_TB = "TB",
  VOLUME_GB = "GB",
  VOLUME_MB = "MB",
  VOLUME_KB = "KB",
  VOLUME_BYTE = "Byte",

  PERCENT = "%",
}

class UnitValue {
  constructor(public letter: UnitNameEnum, public minValue: number) {}
}

class UnitValues {
  constructor(public kind: UnitKindEnum, public values: UnitValue[]) {}
}

export class FormattedResult {
  constructor(public formattedLabel: string, public unit: UnitNameEnum, public originalValue: number) {}
  formattedNumber = Number(this.formattedLabel);
}

class UnitsFormatter {
  private units = [
    new UnitValues(UnitKindEnum.TRAFFIC, [
      new UnitValue(UnitNameEnum.TRAFFIC_PBPS, Math.pow(10, 15)),
      new UnitValue(UnitNameEnum.TRAFFIC_TBPS, Math.pow(10, 12)),
      new UnitValue(UnitNameEnum.TRAFFIC_GBPS, Math.pow(10, 9)),
      new UnitValue(UnitNameEnum.TRAFFIC_MBPS, Math.pow(10, 6)),
      new UnitValue(UnitNameEnum.TRAFFIC_KBPS, Math.pow(10, 3)),
      new UnitValue(UnitNameEnum.TRAFFIC_BPS, 0),
    ]),

    new UnitValues(UnitKindEnum.COUNT, [
      new UnitValue(UnitNameEnum.COUNT_PETA, Math.pow(10, 15)),
      new UnitValue(UnitNameEnum.COUNT_TRILLION, Math.pow(10, 12)),
      new UnitValue(UnitNameEnum.COUNT_BILLION, Math.pow(10, 9)),
      new UnitValue(UnitNameEnum.COUNT_MILLION, Math.pow(10, 6)),
      new UnitValue(UnitNameEnum.COUNT_K, Math.pow(10, 3)),
      new UnitValue(UnitNameEnum.COUNT_NO_UNIT, 0),
    ]),

    new UnitValues(UnitKindEnum.VOLUME, [
      new UnitValue(UnitNameEnum.VOLUME_PB, Math.pow(1024, 5)),
      new UnitValue(UnitNameEnum.VOLUME_TB, Math.pow(1024, 4)),
      new UnitValue(UnitNameEnum.VOLUME_GB, Math.pow(1024, 3)),
      new UnitValue(UnitNameEnum.VOLUME_MB, Math.pow(1024, 2)),
      new UnitValue(UnitNameEnum.VOLUME_KB, 1024),
      new UnitValue(UnitNameEnum.VOLUME_BYTE, 0),
    ]),

    new UnitValues(UnitKindEnum.PERCENT, [new UnitValue(UnitNameEnum.PERCENT, 0)]),
  ];

  private formatNumber(value: number) {
    let absoluteValue = Math.abs(value);

    let precision;
    if (absoluteValue < 10) {
      precision = 2;
    } else if (value < 100) {
      precision = 1;
    } else {
      precision = 0;
    }

    return _.round(value, precision).toFixed(precision);
  }

  public format(originalValue: number, unitsKind: UnitKindEnum): FormattedResult {
    let unit = UnitNameEnum.COUNT_NO_UNIT;
    let newValue: number = 0;

    const matchingUnits = this.units.find(unitValues => unitValues.kind === unitsKind);
    if (!matchingUnits) {
      throw new Error(`no values exist for units kind: ${unitsKind}`);
    }

    let absoluteValue = Math.abs(originalValue);
    for (let value of matchingUnits.values) {
      if (absoluteValue >= value.minValue) {
        if (originalValue === 0) {
          newValue = 0;
        }
        if (value.minValue === 0) {
          newValue = originalValue;
        } else {
          newValue = originalValue / value.minValue;
        }

        unit = value.letter;

        break;
      }
    }

    return new FormattedResult(this.formatNumber(newValue), unit, originalValue);
  }

  public convert(originalValue: number, unitName: UnitNameEnum): FormattedResult {
    for (const unitKind of this.units) {
      for (const unitValue of unitKind.values) {
        if (unitValue.letter.toLowerCase() === unitName.toLowerCase()) {
          let roundedValue = originalValue / unitValue.minValue;
          return new FormattedResult(this.formatNumber(roundedValue), unitName, originalValue);
        }
      }
    }

    throw new Error("unit name not found: " + unitName);
  }
}

export const unitsFormatter = new UnitsFormatter();



// WEBPACK FOOTER //
// ./app/utils/unitsFormatter.ts